import React from "react";
import { MdNavigateNext } from "react-icons/md";
import {
  isValidUrl,
  truncateString,
} from "../../new_appointment/_helper/utils.js/utils";
// import NameAvatar from "./NameAvatar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getImageURL } from "../../_helper/utils/image";

const PatientCardSm = React.forwardRef(
  ({ data, handlePatientDetails }, ref) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const allClinic = searchParams.get("all_clinic");

    return (
      <div
        ref={ref}
        className="w-full h-[54px] flex justify-between items-center gap-3"
        onClick={() => handlePatientDetails(data?.id)}
      >
        <div className="h-10 w-10 rounded-[5px] border">
          {!data?.profile_image ||
          !isValidUrl(getImageURL(data?.profile_image)) ? (
            <div className="bg-[#C7EAC9] w-full h-full uppercase text-white flex justify-center items-center">
              {data?.full_name.split("")[0]}
            </div>
          ) : (
            <img
              style={{ width: "100%", height: "100%" }}
              src={getImageURL(data?.profile_image)}
              alt=".."
            />
          )}
        </div>
        <div className="flex-1">
          <div className="text-[#454545] text-base font-bold">
            {truncateString(data?.full_name, 25)}
          </div>
          <div className="text-[#919191] text-sm leading-4 mt-1">
            {data?.phone}
          </div>
        </div>
        <MdNavigateNext size="24px" color="#676767" className="mr-5" />
      </div>
    );
  }
);

export default PatientCardSm;
